import gql from "graphql-tag";
import {client} from "./client";
import {DeleteEntitygeometryByFulluid} from "../../schema/DeleteEntitygeometryByFulluid";
import {Mutation, FetchResult} from "../../types";

const getMutation = (fullUid: string) => ({
    mutation: gql`${DeleteEntitygeometryByFulluid}`,
    variables: {
        fullUid,
    }
});

export async function deleteEntitygeometryByFullUid (fullUid: string) {
    const geomResult: FetchResult<Mutation> = await client.mutate(getMutation(fullUid));
    return geomResult?.data?.deleteEntitygeometryByFullUid?.entitygeometry;
}

